function initCartRecommendationsCarousel() {
  const slider = document.getElementById('cart-recommendations-slider');
  if (!slider || !window.ThemeCarousel) return;
  if (window.ThemeCarousel.get(slider)) return;

  new window.ThemeCarousel.Carousel(slider, {
    cellSelector: '.cart-recommendations-slide',
    wrapAround: false,
    pageDots: false,
    contain: true,
    prevNextButtons: true,
    adaptiveHeight: false,
    on: {
      ready: function () {
        updateCartRecommendationNavigation(this);
      },
      change: function () {
        updateCartRecommendationNavigation(this);
      },
      scroll: function () {
        updateCartRecommendationNavigation(this);
      }
    }
  });
}

function updateCartRecommendationNavigation(carousel) {
  const prevButton = document.querySelector('#cart-recommendations-prev');
  const nextButton = document.querySelector('#cart-recommendations-next');

  if (!carousel || !carousel.cells || carousel.cells.length <= 1) {
    if (prevButton) prevButton.style.display = 'none';
    if (nextButton) nextButton.style.display = 'none';
    return;
  }

  if (prevButton) {
    prevButton.style.display = carousel.selectedIndex === 0 ? 'none' : 'flex';
  }

  if (nextButton) {
    nextButton.style.display = carousel.selectedIndex >= carousel.cells.length - 1 ? 'none' : 'flex';
  }
}

// Funcionalidad para navegación de productos complementarios en PDP
function initComplementaryProductsNavigation() {
  const slider = document.getElementById('complementary-products-slider');
  const prevButton = document.querySelector('.complementary-products--nav-prev');
  const nextButton = document.querySelector('.complementary-products--nav-next');

  if (!slider || !prevButton || !nextButton || slider.dataset.nativeNavigation === 'true') return;
  slider.dataset.nativeNavigation = 'true';

  const cardWidth = 340;
  const gap = 10;
  const scrollAmount = cardWidth + gap;

  function updateButtonStates() {
    const isAtStart = slider.scrollLeft <= 0;
    const isAtEnd = slider.scrollLeft >= (slider.scrollWidth - slider.clientWidth - 10);

    prevButton.style.opacity = isAtStart ? '0' : '1';
    prevButton.style.visibility = isAtStart ? 'hidden' : 'visible';
    nextButton.style.opacity = isAtEnd ? '0' : '1';
    nextButton.style.visibility = isAtEnd ? 'hidden' : 'visible';
  }

  prevButton.addEventListener('click', function (e) {
    e.preventDefault();
    slider.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });

  nextButton.addEventListener('click', function (e) {
    e.preventDefault();
    slider.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });

  slider.addEventListener('scroll', updateButtonStates);

  updateButtonStates();

  const observer = new MutationObserver(updateButtonStates);
  observer.observe(slider, { childList: true, subtree: true });
}

function observeProductRecommendations() {
  const recommendationsContainerId = 'cart-recommendations-carousel';

  function checkRecommendationsLoaded() {
    const container = document.getElementById(recommendationsContainerId);
    if (container && container.querySelector('.cart-recommendations-slide')) {
      setTimeout(function () {
        initCartRecommendationsCarousel();
      }, 50);
      return true;
    }
    return false;
  }

  if (checkRecommendationsLoaded()) {
    return;
  }
  const bodyObserver = new MutationObserver(function () {
    if (checkRecommendationsLoaded()) {
      bodyObserver.disconnect();
    }
  });
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  const checkInterval = setInterval(function () {
    if (checkRecommendationsLoaded()) {
      clearInterval(checkInterval);
    }
  }, 300);
}

function observeComplementaryProducts() {
  function checkComplementaryProductsLoaded() {
    const slider = document.getElementById('complementary-products-slider');
    if (slider && slider.children.length > 1) {
      setTimeout(function () {
        initComplementaryProductsNavigation();
      }, 100);
      return true;
    }
    return false;
  }

  if (checkComplementaryProductsLoaded()) {
    return;
  }

  const bodyObserver = new MutationObserver(function () {
    if (checkComplementaryProductsLoaded()) {
      bodyObserver.disconnect();
    }
  });
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  const checkInterval = setInterval(function () {
    if (checkComplementaryProductsLoaded()) {
      clearInterval(checkInterval);
    }
  }, 300);
}

function initRecommendations() {
  initCartRecommendationsCarousel();
  observeProductRecommendations();
  observeComplementaryProducts();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecommendations);
} else {
  initRecommendations();
}

document.addEventListener('product:added', function () {
  setTimeout(observeProductRecommendations, 100);
  setTimeout(observeComplementaryProducts, 100);
});

document.addEventListener('cart:updated', function () {
  setTimeout(observeProductRecommendations, 100);
});

document.addEventListener('click', function (e) {
  if (e.target.matches('button[name="checkout"], button[name="add"], .add-to-cart, .cart-link') ||
    e.target.closest('button[name="checkout"], button[name="add"], .add-to-cart, .cart-link')) {
    setTimeout(observeProductRecommendations, 300);
    setTimeout(observeComplementaryProducts, 300);
  }
});

setTimeout(observeProductRecommendations, 1000);
setTimeout(observeProductRecommendations, 2000);
setTimeout(observeComplementaryProducts, 1000);
setTimeout(observeComplementaryProducts, 2000);
